import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import TemplateEditorUtils from '~/Common-Objects/TemplateEditor/Utils'
import { cn } from '~/utils/cn'
import tableRows from './tableRows'
export default class DivCanvasHolder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mouseOver: false
        }
        this.clickHolder = this.clickHolder.bind(this)
        this.mouseEnter = this.mouseEnter.bind(this)
        this.mouseLeave = this.mouseLeave.bind(this)
    }
    clickHolder(event) {
        let okToContinue = TemplateEditorUtils.checkMouseUpHasSelection(event, 'tableOnlyOptions')
        if (!okToContinue) {
            return
        }
        event.stopPropagation()
        this.props.clickElement(this.props.path)
    }
    mouseEnter(event) {
        event.stopPropagation()
        this.setState({ mouseOver: true })
    }
    mouseLeave(event) {
        this.setState({ mouseOver: false })
    }

    render() {
        const { canDrop, isOver, connectDropTarget, connectDragSource, isDragging, moveElement, connectDragPreview } =
            this.props

        var isSelected = this.props.selectedElement.path === this.props.path
        // The light hover outline never shows at the same time as the stronger
        // selected one.
        var showOutline = this.state.mouseOver && isDragging != true && !isSelected
        var isSelectedClass = cn(
            isSelected && 'dndEditorv2-elementHolder--selected',
            showOutline && 'dndEditorv2-elementHolder--hovered',
            isSelected && 'dndEditorv2-elementHolder--chrome',
            this.props.showGuideLines && 'showGuideLines'
        )

        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'table',
                this.props.localVariables
            )
        }
        return (
            <div
                className={cn('dndEditorv2-elementHolder', isSelectedClass)}
                onClick={this.clickHolder}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
            >
                <div className='dndEditorv2-elementHolderTools'>
                    {isSelected && <div className='ui-dd-tools ui-dd-tools-top'></div>}
                    {isSelected && <div className='ui-dd-tools ui-dd-tools-left' alt='Move' title='Move'></div>}
                </div>

                <table {...eleProps}>{tableRows(this.props.children)}</table>
            </div>
        )
    }
}
